export const S3OObjectQueryFragment = /* GraphQL */ `
  bucket
  key
  region
`

export const LocationQueryFragment = /* GraphQL */ `
  streetAddress
  aptNumber
  city
  state
  zipCode
`

export const TimeRangeQueryFragment = /* GraphQL */ `
  startTime {
    hour
    minute
  }
  endTime {
    hour
    minute
  }
`

export const StandardAvailabilityQueryFragment = /* GraphQL */ `
  timezone
  MONDAY {
    ${TimeRangeQueryFragment}
  }
  TUESDAY {
    ${TimeRangeQueryFragment}
  }
  WEDNESDAY {
    ${TimeRangeQueryFragment}
  }
  THURSDAY {
    ${TimeRangeQueryFragment}
  }
  FRIDAY {
    ${TimeRangeQueryFragment}
  }
  SATURDAY {
    ${TimeRangeQueryFragment}
  }
  SUNDAY {
    ${TimeRangeQueryFragment}
  }
`

export const StudioModelQueryFragment = /* GraphQL */ `
  id
  status
  ownerUserId
  standardAvailability {
    ${StandardAvailabilityQueryFragment}
  }
  info {
    title
    description
    rate
    minSessionMinutes
    maxOccupancy
    studioPictures {
      ${S3OObjectQueryFragment}
    }
    location {
      ${LocationQueryFragment}
    }
  }
`

export const BookingModelQueryFragment = /* GraphQL */ `
  id
  status
  studioId
  requesterUserId
  hostUserId
  startTime
  endTime
`
